export default __webpack_public_path__ + "static/media/my_customer_voice_theme_thanks.c9b03602.png";